import {
  facebook,
  youtube,
  linkedin,
  instagram,
} from '@greenkub-fronts/shared/ui';

export interface CustomerFooterProps {
  currentTheme: string;
}

export function CustomerFooter(props: CustomerFooterProps) {
  const { currentTheme } = props;
  return (
    <div className={'Footer ' + currentTheme}>
      <div className="social-network">
        <a target="_blanck" href={'https://www.facebook.com/greenkub.europe'}>
          <img src={facebook} />
        </a>
        <a
          target="_blanck"
          href={'https://www.instagram.com/greenkub.officiel/'}
        >
          <img src={instagram} />
        </a>
        <a target="_blanck" href={'https://www.youtube.com/c/GreenkubFr1'}>
          <img src={youtube} />
        </a>
        <a
          target="_blanck"
          href={'https://www.linkedin.com/company/greenkub/mycompany/'}
        >
          <img src={linkedin} />
        </a>
      </div>
      <div className="address">
        <p>
          Greenkub - 300 avenue de la royale - 34160 Castries -{' '}
          <a
            style={{ color: 'white' }}
            target="_blanck"
            href="https://www.greenkub.fr/mentions-legales"
          >
            Mentions légales
          </a>
        </p>
      </div>
    </div>
  );
}

export default CustomerFooter;
